import { render, staticRenderFns } from "./strength-training.vue?vue&type=template&id=70353140&"
import script from "./strength-training.vue?vue&type=script&lang=js&"
export * from "./strength-training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports